(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/router_desktop.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/router_desktop.js'); svs.TipsetRouter = Backbone.Router.extend({
  currentView: null,
  log: new svs.core.log.Logger('svs.TipsetRouter'),
  hasCheckedExclusion: false,

  initialize: function() {
    this.log.debug('initialize ');
    this.mainContent = $('#tipset');
    this.startPage = $('#startpage');
    this.headerIcon = svs.tipset.models.gameDefinitions.get('htmlClass');
  },

  routes: svs.core.data.routes,

  routeStart: function() {
    if (svs.tipset.views.betslip) {
      svs.tipset.views.betslip.destroy();
      svs.tipset.views.betslip = undefined;

      if (svs.tipset.models.reduceFreeContainer) {
        svs.tipset.models.reduceFreeContainer.set('rows', 0);
      }
    }
    svs.components.dialog.api.close();
    svs.tipset.data.isProlong = false;
    this.match();
  },

  tipsBoard: function() {
    this.match();
  },

  match: function() {
    if (svs.tipset.collections.draws && svs.tipset.collections.draws.any()) {
      var did = svs.tipset.collections.draws.getCurrentDraw().get('urlAddOn'),
        url = '',
        couponColumn = $('#couponColumn'),
        statsColumn = $('#statsColumn'),
        currentCompetitionUrl =
          svs.tipset.data.competition && svs.tipset.data.competition.clientUrl
            ? svs.tipset.data.competition.clientUrl + '/'
            : '';

      if (couponColumn) {
        couponColumn.show();
      }
      if (statsColumn) {
        statsColumn.show();
      }

      url = currentCompetitionUrl + did;

      var tipssmOrQuerystring = svs.tipset.data.competitionInvite
        ? 'tips-sm'
        : svs.utils.url.queryString.flik;

      if (svs.tipset.data.queryString && tipssmOrQuerystring) {
        var query = svs.utils.url.updateQueryStringParameter(
          window.location.search,
          'flik',
          tipssmOrQuerystring
        );

        if (query !== '?' && query !== '&') {
          url += query;
        }
      } else {
        url += window.location.search;
      }

      var options = { trigger: false };
      if (!svs.core.detect.formfactor.mobile()) {
        options.replace = true;
      }

      svs.obj.router.navigate(url, { trigger: false, replace: true });

      svs.tipset.app.rootView.showChildView(
        'mainArea',
        new svs.tipset.views.Play({ model: svs.tipset.models.play })
      );
    } else {
      svs.tipset.app.rootView.showChildView(
        'mainArea',
        new svs.tipset.views.Play({ model: svs.tipset.models.play })
      );
    }
  },

  competition: function(round, match) {
    if (match === undefined) {
      this.tipsBoard(round, undefined);
    } else {
      this.match(round, match);
    }
  },

  prolongGame: function() {
    svs.tipset.data.isProlong = true;
    this.tipsBoard();
  },

  competitionInvite: function() {
    this.match();
  }
});

 })(window);